module.exports = __webpack_public_path__ + "img/bg-angela-guzman.cd78fd99.jpg";